const {
  RichText,
  MediaUpload,
  MediaUploadCheck,
  InspectorControls,
  InnerBlocks,
} = wp.blockEditor;
const { Button, PanelBody, SelectControl } = wp.components;
const { Fragment } = wp.element;
const { registerBlockType } = wp.blocks;
const { __ } = wp.i18n;

registerBlockType('pg/image-content-section', {
  title: __('PG Image Content Section'),
  icon: 'format-image',
  category: 'layout',
  attributes: {
    heading: { type: 'string', default: '' },
    imgSrc: { type: 'string', default: '' },
    imgAlt: { type: 'string', default: '' },
    orientation: { type: 'string', default: 'image-on-left' },
    sectionClass: { type: 'string', default: 'section-light-primary' },
    cornerPositionClass: { type: 'string', default: 'corner-disabled' },
    cornerBackgroundClass: {
      type: 'string',
      default: 'corner-on-light-primary',
    },
  },
  edit: ({ attributes, setAttributes }) => {
    const {
      heading,
      imgSrc,
      imgAlt,
      orientation,
      sectionClass,
      cornerPositionClass,
      cornerBackgroundClass,
    } = attributes;

    const onSelectImage = (media) => {
      setAttributes({ imgSrc: media.url, imgAlt: media.alt || '' });
    };

    return (
      <Fragment>
        <InspectorControls>
          <PanelBody title={__('Settings')}>
            <SelectControl
              label={__('Image Orientation')}
              value={orientation}
              options={[
                { label: __('Left'), value: 'image-on-left' },
                { label: __('Right'), value: 'image-on-right' },
              ]}
              onChange={(value) => setAttributes({ orientation: value })}
            />
            <SelectControl
              label={__('Section Class')}
              value={sectionClass}
              options={[
                { label: 'Dark Secondary', value: 'section-dark-secondary' },
                { label: 'Dark Primary', value: 'section-dark-primary' },
                { label: 'Light Primary', value: 'section-light-primary' },
                { label: 'Light Secondary', value: 'section-light-secondary' },
              ]}
              onChange={(value) => setAttributes({ sectionClass: value })}
            />
            <SelectControl
              label={__('Corner Position')}
              value={cornerPositionClass}
              options={[
                { label: 'None', value: 'corner-disabled' },
                { label: 'Left Top', value: 'corner-left-top' },
                { label: 'Left Bottom', value: 'corner-left-bottom' },
                { label: 'Right Top', value: 'corner-right-top' },
                { label: 'Right Bottom', value: 'corner-right-bottom' },
              ]}
              onChange={(value) =>
                setAttributes({ cornerPositionClass: value })
              }
            />
            <SelectControl
              label={__('Corner Background')}
              value={cornerBackgroundClass}
              options={[
                { label: 'Dark Primary', value: 'corner-on-dark-primary' },
                { label: 'Dark Secondary', value: 'corner-on-dark-secondary' },
                { label: 'Light Primary', value: 'corner-on-light-primary' },
                {
                  label: 'Light Secondary',
                  value: 'corner-on-light-secondary',
                },
              ]}
              onChange={(value) =>
                setAttributes({ cornerBackgroundClass: value })
              }
            />
          </PanelBody>
        </InspectorControls>
        <section className={sectionClass}>
          <div
            className={`corner ${cornerPositionClass} ${sectionClass.replace('section', 'corner')} ${cornerBackgroundClass}`}
          ></div>
          <div className={`image-content-wrapper ${orientation}`}>
            <div className="image-wrapper">
              <MediaUploadCheck>
                <MediaUpload
                  onSelect={onSelectImage}
                  allowedTypes={['image']}
                  value={imgSrc}
                  render={({ open }) => (
                    <Button onClick={open} isPrimary>
                      {imgSrc ? __('Change Image') : __('Upload Image')}
                    </Button>
                  )}
                />
              </MediaUploadCheck>
              {imgSrc && <img src={imgSrc} alt={imgAlt || ''} />}
            </div>
            <div className="content-wrapper">
              <RichText
                tagName="h2"
                value={heading}
                onChange={(value) => setAttributes({ heading: value })}
                placeholder={__('Heading')}
              />
              <InnerBlocks
                allowedBlocks={[
                  'core/paragraph',
                  'core/image',
                  'core/heading',
                  'core/list',
                  'core/embed',
                  'core/table',
                  'core/freeform',
                  'core/quote',
                  'pg/button',
                  'pg/banner',
                  'pg/list',
                ]}
                template={[
                  [
                    'core/paragraph',
                    {
                      placeholder: 'Start writing or type / to choose a block',
                    },
                  ],
                ]}
              />
            </div>
          </div>
        </section>
      </Fragment>
    );
  },
  save: ({ attributes }) => {
    const {
      heading,
      imgSrc,
      imgAlt,
      orientation,
      sectionClass,
      cornerPositionClass,
      cornerBackgroundClass,
    } = attributes;
    return (
      <section className={sectionClass}>
        <div
          className={`corner ${cornerPositionClass} ${sectionClass.replace('section', 'corner')} ${cornerBackgroundClass}`}
        ></div>
        <div className={`image-content-wrapper ${orientation}`}>
          <div className="image-wrapper">
            {imgSrc && <img src={imgSrc} alt={imgAlt || ''} />}
          </div>
          <div className="content-wrapper">
            <h2>{heading}</h2>
            <InnerBlocks.Content />
          </div>
        </div>
      </section>
    );
  },
});
